import { render, staticRenderFns } from "./Collatoral.vue?vue&type=template&id=5220eee8"
import script from "./Collatoral.vue?vue&type=script&lang=js"
export * from "./Collatoral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports